import * as Yup from "yup";

export const BlogValidationSchema = Yup.object().shape({
  blog_comment: Yup.string().required("Field is required"),
});

export const AddBlogInitialValues = {
  blog_comment: "",
};
